import './DashboardTabHeader.css';

import useGettingCustomDashboards from '../hooks/useGettingCustomDashboards';
import { useNavigate } from 'react-router-dom';
import { Tab, Tabs } from '@mui/material';
import { generateClassName } from '../../b2b-common/helpers';
import { useState, useEffect } from 'react';

const DashboardTabHeader = ({ dashboard, className = null }) => {
    const navigate = useNavigate();
    const { customDashboards, isLoading } = useGettingCustomDashboards();
    const [selectedTab, setSelectedTab] = useState(dashboard.dashboardId); // Initialize with the 'dashboard' prop

    useEffect(() => {
        setSelectedTab(dashboard.dashboardId); // Update selectedTab if 'dashboard' prop changes
    }, [dashboard]);

    if (isLoading || !customDashboards) {
        return <div>Loading...</div>;
    }

    const handleTabChange = (event, dashboardId) => {
        setSelectedTab(dashboardId); // Update the selected tab
        navigate(`/reporting/dashboards/${dashboardId}`);
    };

    return (
        <Tabs
            value={selectedTab} // Set the selected tab
            onChange={(event, newValue) => handleTabChange(event, newValue)}
            className={generateClassName('dashboard-tab-header', '', className)}
            variant='scrollable'
            scrollButtons='auto'
        >
            {customDashboards.map((dashboard) => (
                <Tab
                    key={dashboard.dashboardId}
                    value={dashboard.dashboardId} // Set the value for each tab
                    label={dashboard.dashboardName}
                    className={'dashboard-tab-header-name'}
                    aria-selected={selectedTab === dashboard.dashboardId} // Check if the tab is selected
                />
            ))}
        </Tabs>
    );
}

export default DashboardTabHeader;